// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1k9ez","buttons":"Footer_buttons__3NeS4"};